import { useAtomValue } from 'jotai';
import { createHtmlSignDocumentAtom } from '../../../store/global/atoms/documents-atoms';

export const useCreateHtmlSignDocument = () => {
  const createHtmlSignDocument = useAtomValue(createHtmlSignDocumentAtom);

  return {
    htmlSignDocumentCreatedData: createHtmlSignDocument.data,
    createHtmlSignDocument: createHtmlSignDocument.mutate,
    createHtmlSignDocumentAsync: createHtmlSignDocument.mutateAsync,
    error: createHtmlSignDocument.error,
    isLoading: createHtmlSignDocument.isPending,
  };
};
